<template>
  <div class="covers">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide-first">
          <div class="home">
            <div class="home_title">
              <h5>【調查報導】</h5>
              <h1>建築耐震補強20年仍牛步<br>下次地震怎麼辦？</h1>
              <p>921地震20年，台灣公共和私有建築耐震改善了多少？《聯合報》查閱政府資料，體檢全台公共和私有建築耐震補強狀況，一同檢視政府交出什麼樣的成績單。</p>
            </div>
            <div class="home_links">
              <div class="home_link home_link-1">
                <a to="/public_building">
                  <div class="home_link_name">
                    <p class="text-shadow">1&nbsp;&nbsp;&nbsp;&nbsp;公共建築補強 行政院掛蛋&nbsp;</p>     
                    <span></span>
                    <scroll-down-arrow class="home_arrow"
                      :icon-color="'white'"
                    />
                  </div>
                </a>
              </div>
              <div class="home_link home_link-2">
                <a to="/damaged_building">
                  <div class="home_link_name">
                    <p class="text-shadow">2&nbsp;&nbsp;&nbsp;&nbsp;5萬棟近斷層老屋 藏風險&nbsp;&nbsp;</p>
                    <span></span>
                    <scroll-down-arrow class="home_arrow"
                      :icon-color="'white'"
                    />
                  </div>
                </a>
              </div>
              <div class="home_link home_link-3">
                <a to="/earthquake_resistance">
                  <div class="home_link_name">
                    <p class="text-shadow">3&nbsp;&nbsp;&nbsp;&nbsp;私有建築補強 20年沒進展</p>
                    <span></span>
                    <scroll-down-arrow class="home_arrow"
                      :icon-color="'white'"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide" :style="{background: `url('${srcRWD('static/image/livecover_01_mob.jpg', 'static/image/livecover_01.jpg')}')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
          <div class="cover">
            <div class="h50px"></div>
            <div class="cover_title">
              <h5 class="text-shadow">【建築耐震總體檢1】</h5>
              <br v-if="this.isWeb">
              <h1 class="bold text-shadow">公共建築耐震補強<br v-if="!this.isWeb"> 行政院掛蛋</h1>
            </div>
          </div>
        </div>
        <div class="swiper-slide" :style="{background: `url('${srcRWD('static/image/livecover_02_mob.jpg', 'static/image/livecover_02.jpg')}')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
          <div class="cover">
            <div class="h50px"></div>
            <div class="cover_title">
              <h5 class="text-shadow">【建築耐震總體檢2】</h5>
              <br v-if="this.isWeb">
              <h1 class="bold text-shadow">近斷層老舊建築<br v-if="!this.isWeb"> 5萬棟暗藏風險</h1>
            </div>
          </div>
        </div>
        <div class="swiper-slide" :style="{background: `url('${srcRWD('static/image/livecover_03_mob.jpg', 'static/image/livecover_03.jpg')}')`, backgroundSize: 'cover', backgroundPosition: 'center' }">
          <div class="cover">
            <div class="h50px"></div>
            <div class="cover_title">
              <h5 class="text-shadow">【建築耐震總體檢3】</h5>
              <br v-if="this.isWeb">
              <h1 class="bold text-shadow">私有建築補強卡關<br v-if="!this.isWeb"> 防災成空談</h1>
            </div>
          </div>
        </div>
      </div>
      <div v-show="showArrow" class="swiper-button-next" :style="{background: `url('${srcRWD('static/image/livearrow_right.svg', 'static/image/webarrow_right.svg')}')`, backgroundSize: 'cover'}"><span class="right-link-name text-shadow">{{this.rightLinkName}}</span></div>
      <div v-show="showArrow" class="swiper-button-prev" :style="{background: `url('${srcRWD('static/image/livearrow_left.svg', 'static/image/webarrow_left.svg')}')`, backgroundSize: 'cover'}"><span class="left-link-name text-shadow">{{this.leftLinkName}}</span></div>
      <div v-show="showArrow" class="arrow">
        <span class="text-shadow">閱讀內文</span>
        <scroll-down-arrow
          :icon-color="'white'"
          v-scroll-to="{
            el:'.page',
            duration: 1500
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ScrollDownArrow from './ScrollDownArrow.vue'

export default {
  name: 'Covers',
  components: {
    ScrollDownArrow
  },
  data() {
    return {
      isWeb: false,
      swiper: null,
      showArrow: false,
      leftLinkName: '',
      rightLinkName: ''
    }
  },
  methods: {
    srcRWD(mob,web){
      if(this.isWeb==false){
        return mob;
      }else{
        return web;
      }
    },
    detectPlatform() {
      if( navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)
      ){
          return 'Mob';
      }
      else {
          return 'PC';
      }
    }
  },
  computed: {
  },
  created() {
    if (window.innerWidth >= 768) {
      this.isWeb = true
    }
  },
  watch: {
    '$route' (to, from) {
      let vm = this
      if(to.path=='/'){
        vm.swiper.slideTo(1)
        vm.showArrow = false
      }
      if(to.path=='/public_building'){
        vm.swiper.slideTo(2)
        vm.showArrow = true
        vm.leftLinkName = '回首頁'
        vm.rightLinkName = '近斷層高風險建築'
      }
      if(to.path=='/damaged_building'){
        vm.swiper.slideTo(3)
        vm.showArrow = true
        vm.leftLinkName = '公建築補強牛步'
        vm.rightLinkName = '私建築補強卡關'
      }
      if(to.path=='/earthquake_resistance'){
        vm.swiper.slideTo(4)
        vm.showArrow = true
        vm.leftLinkName = '近斷層高風險建築'
        vm.rightLinkName = '回首頁'
      }
    }
  },
  mounted() {
    // console.log(this.$router)
    let vm = this
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // allowTouchMove: false,
      // pagination: {
      //   el: '.swiper-pagination',
      //   clickable: true,
      // },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
    vm.swiper = swiper
    swiper.on('slideChange', function () {
      // console.log(swiper.realIndex)
      if(swiper.realIndex == '0') {
        vm.$router.push('/')
        // console.log('0: '+swiper.realIndex)
      }
      if(swiper.realIndex == '1') {
        vm.$router.push('/public_building')
        // console.log('1: '+swiper.realIndex)
      }
      if(swiper.realIndex == '2') {
        vm.$router.push('/damaged_building')
        // console.log('2: '+swiper.realIndex)
      }
      if(swiper.realIndex == '3') {
        vm.$router.push('/earthquake_resistance')
        // console.log('3: '+swiper.realIndex)
      }
    });

    swiper.allowTouchMove = false

    document.querySelector('.home_link-1').addEventListener('click', (event) => {
      // console.log(event)
      ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'three page',
        eventAction: 'Click',
        eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [page 1]`,
      })
      swiper.slideTo(2)
    })
    document.querySelector('.home_link-2').addEventListener('click', (event) => {
      // console.log(event)
      ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'three page',
        eventAction: 'Click',
        eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [page 2]`,
      })
      swiper.slideTo(3)
    })
    document.querySelector('.home_link-3').addEventListener('click', (event) => {
      // console.log(event)
      ga('newmedia.send', {
        hitType: 'event',
        eventCategory: 'three page',
        eventAction: 'Click',
        eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [page 3]`,
      })
      swiper.slideTo(4)
    })
    // GA
    document.querySelector('.swiper-button-prev').addEventListener('click', (event) => {
      switch(this.$router.history.current.path){
        case '/':
          // console.log('pre_page 1')
          ga('newmedia.send', {
            hitType: 'event',
            eventCategory: 'lead button',
            eventAction: 'Click',
            eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [pre_page 1]`,
          })
          break
        case '/public_building':
          // console.log('pre_page 2')
          ga('newmedia.send', {
            hitType: 'event',
            eventCategory: 'lead button',
            eventAction: 'Click',
            eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [pre_page 2]`,
          })
          break
        case '/damaged_building':
          // console.log('pre_page 3')
          ga('newmedia.send', {
            hitType: 'event',
            eventCategory: 'lead button',
            eventAction: 'Click',
            eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [pre_page 3]`,
          })
          break
      }
    })

    document.querySelector('.swiper-button-next').addEventListener('click', (event) => {
      switch(this.$router.history.current.path){
        case '/damaged_building':
          // console.log('next_page 1')
          ga('newmedia.send', {
            hitType: 'event',
            eventCategory: 'lead button',
            eventAction: 'Click',
            eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [next_page 1]`,
          })
          break
        case '/earthquake_resistance':
          // console.log('next_page 2')
          ga('newmedia.send', {
            hitType: 'event',
            eventCategory: 'lead button',
            eventAction: 'Click',
            eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [next_page 2]`,
          })
          break
        case '/':
          // console.log('next_page 3')
          ga('newmedia.send', {
            hitType: 'event',
            eventCategory: 'lead button',
            eventAction: 'Click',
            eventLabel: `[${this.detectPlatform()}] [${document.querySelector('title').innerHTML}] [next_page 3]`,
          })
          break
      }
    })
    
    

    if(this.$router.history.current.path=='/'){
      swiper.slideTo(1)
      vm.showArrow = false
    }
    if(this.$router.history.current.path=='/public_building'){
      swiper.slideTo(2)
      vm.showArrow = true
      vm.leftLinkName = '回首頁'
      vm.rightLinkName = '近斷層高風險建築'
    }
    if(this.$router.history.current.path=='/damaged_building'){
      swiper.slideTo(3)
      vm.showArrow = true
      vm.leftLinkName = '公共建築補強牛步'
      vm.rightLinkName = '私有建築補強卡關'
    }
    if(this.$router.history.current.path=='/earthquake_resistance'){
      swiper.slideTo(4)
      vm.showArrow = true
      vm.leftLinkName = '近斷層高風險建築'
      vm.rightLinkName = '回首頁'
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.text-shadow
  text-shadow: 0 0 13px rgba(0, 0, 0, 0.5)
.covers
  position: relative
  width: 100%
  height: 100vh
.h50px
  width: 100%
  height: 50px
  @media screen and (min-width: 768px)
    flex: 0
.cover
  position: relative
  width: 100%
  height: 100vh
  // background-image: url('../../public/static/image/livecover_01_mob.jpg')
  background-size: cover
  @media screen and (min-width: 768px)
    display: flex
    justify-content: center
    align-items: center
  h1, h5
    color: white
.cover_title
  width: 100%
  padding: 3rem 4rem
  @media screen and (min-width: 768px)
    width: auto
    position: relative
    display: inline-block
    transform: translate(0, -110px)
    h1, h5
      display: inline-block
  .h1-1
    &:before
      display: block
      content: '1'
      font-size: 110px
      font-weight: normal
      position: absolute
      transform: translate(-100%, -28px)
      @media screen and (min-width: 768px)
        display: none
  .h1-2
    &:before
      display: block
      content: '2'
      font-size: 110px
      font-weight: normal
      position: absolute
      transform: translate(-100%, -28px)
      @media screen and (min-width: 768px)
        display: none
  .h1-3
    &:before
      display: block
      content: '3'
      font-size: 110px
      font-weight: normal
      position: absolute
      transform: translate(-100%, -28px)
      @media screen and (min-width: 768px)
        display: none
      
      
.link-container
  padding: 0 1rem
  width: 100%
  position: absolute
  bottom: 25%
  right: 0
  display: flex
  justify-content: space-between
  @media (min-width: 768px) and (max-width: 1024px)
    bottom: 30%
  @media screen and (min-width: 1025px)
    bottom: 50%
    transform: translate(0, -50%)
    padding: 0 5rem
  a
    text-decoration: none
.router-link
  display: flex
  align-items: center
  color: #fff
  span
    margin: 0
  .router-link_leftImage
    padding-right: 5px
  .router-link_rightImage
    padding-left: 5px
.arrow
  width: 100%
  position: absolute
  bottom: 10%
  right: 0
  text-align: center
  color: #fff
  z-index: 1

.swiper-container
  width: 100%
  height: 100%
  position: absolute
  top: 0
  left: 0
.swiper-slide
  width: 100%
  height: 100%
.swiper-slide-first
  width: 100% !important
.swiper-button-next, .swiper-button-prev
  width: 28px
  height: 28px
  transform: translate(0, 2rem)
  &:focus
    outline: none
  @media (min-width: 768px)
    width: 40px
    height: 77px
    transform: translate(0, 0)

// Home
.bold
  font-weight: bold
.h50px
  width: 100%
  height: 50px
.home
  width: 100%
  height: 100vh
  display: flex
  flex-wrap: wrap
  background-image: url('../../public/static/image/livecover_00_mob.jpg')
  background-size: cover
  overflow: auto
  @media screen and (min-width: 768px)
    background-image: url('../../public/static/image/livecover_00.jpg')
  .home_title
    padding: 4rem 2rem 0 2rem
    text-align: initial
    width: 100%
    h1, h5
      animation: titleAni 2s forwards
    @media screen and (min-width: 768px)
      padding: 10% 15% 4% 15%
    p
      margin: 0
      opacity: 0
      animation: titleAni 2s 0.8s forwards
  .home_arrow
    position: absolute
    top: -12px
    right: -50px
    transform: rotate(-90deg)
    @media screen and (min-width: 768px)
      position: absolute
      top: -10px
      right: -50px
.home_links
  width: 100%
  padding: 10px 0
  background: rgba(40,40,40,0.35)
  overflow: hidden
.home_link
  position: relative
  z-index: 10
  padding: 10px 2em
  @media screen and (min-width: 768px)
    padding: 10px 15%
  a
    color: white
    text-decoration: none
  .home_link_name
    cursor: pointer
    position: relative
    display: inline-block
    @media screen and (min-width: 768px)
      display: inline-block
      border-width: 0
      &:hover
        span:before
          transform: scaleX(1)
      span
        transform: rotate(180deg)
        position: absolute
        top: 0
        left: 0
        width: calc(100% + 50px)
        height: 100%
        display: block
        margin: 0
        &:before 
          content: ''
          position: absolute
          width: 100%
          height: 1px
          background: #00ffca
          transition: 0.3s linear
          transform: scaleX(0)
          transform-origin: right
    p
      margin: 0

.right-link-name
  position: absolute
  color: #fff
  left: 0
  top: 50%
  transform: translate(-100%, -50%)
  white-space: nowrap
.left-link-name
  position: absolute
  color: #fff
  right: 0
  top: 50%
  transform: translate(100%, -50%)
  white-space: nowrap
@keyframes titleAni  
  0%
    opacity: 0
    transform: translate(0, 50px)
  100%
    opacity: 1
    transform: translate(0, 0)
</style>
